<div [class.mt-3]="!noMargin">
  <i class="fal fa-spinner fa-spin mr-2"></i>
  {{ text }}
</div>
